module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filterRow">\n    <select class="filterSelect">\n    </select>\n    <select class="operation">\n    </select>\n    <div class="picker">\n    </div>\n</div>    ';

}
return __p
}